/* eslint-disable no-unused-vars */
import { CallbirdButton } from "components/CallbirdButton";
import React from "react";
import cn from "classnames";

const CallbirdComponent = ({ state: { alignment } }) => {
    return (
        <div
            className={cn(`flex w-full`, {
                "justify-start": alignment === "left",
                "justify-center": alignment === "center",
                "justify-end": alignment === "right",
            })}
        >
            <CallbirdButton />
        </div>
    );
};

export default CallbirdComponent;
